import React, { useState, useEffect } from 'react';
import { Grid, Box, Link, Typography, IconButton } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';
import { ConfirmModal } from 'components';

interface DegreeField {
    degree: string;
}

const DegreesField = ({ degreesData, setDegreesData, setShowIcons }: any) => {
    const [degreeInput, setDegreeInput] = useState<string>('');
    const [degreeFields, setDegreeFields] = useState<DegreeField[]>(
        degreesData?.degrees?.length > 0 ? degreesData?.degrees : []
    );
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [degreeToDelete, setDegreeToDelete] = useState<number | null>(null); // Store index to delete

    // Update parent state when degreeFields change
    useEffect(() => {
        setDegreesData({ degrees: degreeFields });

        setShowIcons((prevState: any) => ({
            ...prevState,
            degrees: degreeFields.length > 0, // true if there are degrees, false otherwise
        }));

    }, [degreeFields, setDegreesData]);

    // Handle input field change
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDegreeInput(e.target.value);
    };

    // Add degree to the list and clear the input field
    const addDegreeField = () => {
        if (degreeInput.trim() === '') return; // Do nothing if the input is empty
        setDegreeFields([...degreeFields, { degree: degreeInput }]);
        setDegreeInput(''); // Clear the input field after adding
    };

    // Open modal and store the index of the degree to be deleted
    const handleOpenModal = (index: number) => {
        setDegreeToDelete(index);
        setIsModalOpen(true);
    };

    // Remove a degree field
    const removeDegreeField = (index: number) => {
        const newDegreeFields = degreeFields.filter((_, i) => i !== index);
        setDegreeFields(newDegreeFields);
    };

    return (
        <Grid display={"flex"} gap={5} flexDirection={"column"} p={{ xs: 2, md: 5 }} mt={{ xs: 3, md: 0 }}>
            <Grid item xs={12} sm={6} display={"flex"} gap={1} flexDirection={"column"}>
                <label htmlFor="degree" style={styleSheet.labelText}>
                    Degrees
                </label>

                {/* Input field to add a new degree */}
                <Grid display={"flex"} alignItems={"center"} flex={1} mb={2} >
                    <Box sx={{ flexGrow: 1, display: "flex", gap: 1, alignItems: "center" }}
                    >
                        <CustomTextField
                            name="degree"
                            type='text'
                            sx={{ width: '100%', maxWidth: '599px' }}
                            value={degreeInput}
                            onChange={handleInputChange}
                        />
                        <Link
                            onClick={addDegreeField}
                            sx={{ width: { xs: "60%", md: "20%" }, color: "#233F91", fontSize: "17px", fontWeight: 400, cursor: 'pointer' }}
                        >
                            Add a Degree
                        </Link>
                    </Box>
                </Grid>

                {/* Render the list of saved degrees */}
                {degreeFields.map((degree, index) => (
                    <Grid key={index} display={"flex"} alignItems={"center"} flex={1} mb={2}>
                        <Box sx={{ flexGrow: 1, display: "flex", gap: 1, alignItems: "center" }}>
                            <Box sx={{
                                width: "599px", height: "51px", border: "1px solid #C9C9C9",
                                borderRadius: "9px",
                                display: "flex", alignItems: "center",
                            }}>
                                <Typography ml={2} fontSize={"18px"} fontWeight={700} color={"#595959"}>
                                    {degree.degree}
                                </Typography>
                            </Box>
                            <IconButton onClick={() => handleOpenModal(index)} sx={{ color: "#FF0000" }}>
                                <img src='assets/icons/iconDelete.png' alt='delete' />
                            </IconButton>
                        </Box>
                    </Grid>
                ))}
            </Grid>
            <ConfirmModal
                title="You’re About to Delete a File"
                subtitle="Figma ipsum component variant main layer. Line horizontal arrange team editor thumbnail distribute. Follower figma blur connection slice plugin. Text mask hand bullet ipsum slice mask selection bullet list. Polygon align hand bold."
                cancelText="Cancel"
                confirmText="Confirm"
                titleColor="#233F91"
                isLoading={false}
                onCancel={() => setIsModalOpen(false)}
                onConfirm={() => {
                    if (degreeToDelete !== null) {
                        removeDegreeField(degreeToDelete);
                        setIsModalOpen(false);
                    }
                }}
                isConfirmModal={isModalOpen}
            />
        </Grid>
    );
};

export default DegreesField;

const styleSheet = {
    labelText: {
        fontWeight: 400,
        fontSize: "17px",
        color: "#000000",
    }
};
